const get = require("lodash.get");

exports.query = `
{
  a: allKontentItemPage(
    filter: {elements: {content: {value: {elemMatch: {system: {type: {eq: "content___sotd"}}}}}, title: {value: {regex: "/^(A|a).+/"}}}}
    sort: { elements: {url: {value: ASC}}}
  ) {
    totalCount
    nodes {
      ...scientistLink
    }
  }
  b: allKontentItemPage(
    filter: {elements: {content: {value: {elemMatch: {system: {type: {eq: "content___sotd"}}}}},
    title: {value: {regex: "/^(B|b).+/"}}}}
    sort: { elements: {url: {value: ASC}}}  ) {
    totalCount
    nodes {
      ...scientistLink
    }
  }
  c: allKontentItemPage(
    filter: {elements: {content: {value: {elemMatch: {system: {type: {eq: "content___sotd"}}}}},
    title: {value: {regex: "/^(C|c).+/"}}}}
    sort: { elements: {url: {value: ASC}}}  ) {
    totalCount
    nodes {
      ...scientistLink
    }
  }
  d: allKontentItemPage(
    filter: {elements: {content: {value: {elemMatch: {system: {type: {eq: "content___sotd"}}}}},
    title: {value: {regex: "/^(D|d).+/"}}}}
    sort: { elements: {url: {value: ASC}}}  ) {
    totalCount
    nodes {
      ...scientistLink
    }
  }
  e: allKontentItemPage(
    filter: {elements: {content: {value: {elemMatch: {system: {type: {eq: "content___sotd"}}}}},
    title: {value: {regex: "/^(E|e).+/"}}}}
    sort: { elements: {url: {value: ASC}}}  ) {
    totalCount
    nodes {
      ...scientistLink
    }
  }
  f: allKontentItemPage(
    filter: {elements: {content: {value: {elemMatch: {system: {type: {eq: "content___sotd"}}}}},
    title: {value: {regex: "/^(F|f).+/"}}}}
    sort: { elements: {url: {value: ASC}}}  ) {
    totalCount
    nodes {
      ...scientistLink
    }
  }
  g: allKontentItemPage(
    filter: {elements: {content: {value: {elemMatch: {system: {type: {eq: "content___sotd"}}}}},
    title: {value: {regex: "/^(G|g).+/"}}}}
    sort: { elements: {url: {value: ASC}}}  ) {
    totalCount
    nodes {
      ...scientistLink
    }
  }
  h: allKontentItemPage(
    filter: {elements: {content: {value: {elemMatch: {system: {type: {eq: "content___sotd"}}}}},
    title: {value: {regex: "/^(H|h).+/"}}}}
    sort: { elements: {url: {value: ASC}}}  ) {
    totalCount
    nodes {
      ...scientistLink
    }
  }
  i: allKontentItemPage(
    filter: {elements: {content: {value: {elemMatch: {system: {type: {eq: "content___sotd"}}}}},
    title: {value: {regex: "/^(I|i).+/"}}}}
    sort: { elements: {url: {value: ASC}}}  ) {
    totalCount
    nodes {
      ...scientistLink
    }
  }
  j: allKontentItemPage(
    filter: {elements: {content: {value: {elemMatch: {system: {type: {eq: "content___sotd"}}}}},
    title: {value: {regex: "/^(J|j).+/"}}}}
    sort: { elements: {url: {value: ASC}}}  ) {
    totalCount
    nodes {
      ...scientistLink
    }
  }
  k: allKontentItemPage(
    filter: {elements: {content: {value: {elemMatch: {system: {type: {eq: "content___sotd"}}}}},
    title: {value: {regex: "/^(K|k).+/"}}}}
    sort: { elements: {url: {value: ASC}}}  ) {
    totalCount
    nodes {
      ...scientistLink
    }
  }
  l: allKontentItemPage(
    filter: {elements: {content: {value: {elemMatch: {system: {type: {eq: "content___sotd"}}}}},
    title: {value: {regex: "/^(L|l).+/"}}}}
    sort: { elements: {url: {value: ASC}}}  ) {
    totalCount
    nodes {
      ...scientistLink
    }
  }
  m: allKontentItemPage(
    filter: {elements: {content: {value: {elemMatch: {system: {type: {eq: "content___sotd"}}}}},
    title: {value: {regex: "/^(M|m).+/"}}}}
    sort: { elements: {url: {value: ASC}}}  ) {
    totalCount
    nodes {
      ...scientistLink
    }
  }
  n: allKontentItemPage(
    filter: {elements: {content: {value: {elemMatch: {system: {type: {eq: "content___sotd"}}}}},
    title: {value: {regex: "/^(N|n).+/"}}}}
    sort: { elements: {url: {value: ASC}}}  ) {
    totalCount
    nodes {
      ...scientistLink
    }
  }
  o: allKontentItemPage(
    filter: {elements: {content: {value: {elemMatch: {system: {type: {eq: "content___sotd"}}}}},
    title: {value: {regex: "/^(O|o).+/"}}}}
    sort: { elements: {url: {value: ASC}}}  ) {
    totalCount
    nodes {
      ...scientistLink
    }
  }
  p: allKontentItemPage(
    filter: {elements: {content: {value: {elemMatch: {system: {type: {eq: "content___sotd"}}}}},
    title: {value: {regex: "/^(P|p).+/"}}}}
    sort: { elements: {url: {value: ASC}}}  ) {
    totalCount
    nodes {
      ...scientistLink
    }
  }
  q: allKontentItemPage(
    filter: {elements: {content: {value: {elemMatch: {system: {type: {eq: "content___sotd"}}}}},
    title: {value: {regex: "/^(Q|q).+/"}}}}
    sort: { elements: {url: {value: ASC}}}  ) {
    totalCount
    nodes {
      ...scientistLink
    }
  }
  r: allKontentItemPage(
    filter: {elements: {content: {value: {elemMatch: {system: {type: {eq: "content___sotd"}}}}},
    title: {value: {regex: "/^(R|r).+/"}}}}
    sort: { elements: {url: {value: ASC}}}  ) {
    totalCount
    nodes {
      ...scientistLink
    }
  }
  s: allKontentItemPage(
    filter: {elements: {content: {value: {elemMatch: {system: {type: {eq: "content___sotd"}}}}},
    title: {value: {regex: "/^(S|s).+/"}}}}
    sort: { elements: {url: {value: ASC}}}  ) {
    totalCount
    nodes {
      ...scientistLink
    }
  }
  t: allKontentItemPage(
    filter: {elements: {content: {value: {elemMatch: {system: {type: {eq: "content___sotd"}}}}},
    title: {value: {regex: "/^(T|t).+/"}}}}
    sort: { elements: {url: {value: ASC}}}  ) {
    totalCount
    nodes {
      ...scientistLink
    }
  }
  u: allKontentItemPage(
    filter: {elements: {content: {value: {elemMatch: {system: {type: {eq: "content___sotd"}}}}},
    title: {value: {regex: "/^(U|u).+/"}}}}
    sort: { elements: {url: {value: ASC}}}  ) {
    totalCount
    nodes {
      ...scientistLink
    }
  }
  v: allKontentItemPage(
    filter: {elements: {content: {value: {elemMatch: {system: {type: {eq: "content___sotd"}}}}},
    title: {value: {regex: "/^(V|v).+/"}}}}
    sort: { elements: {url: {value: ASC}}}  ) {
    totalCount
    nodes {
      ...scientistLink
    }
  }
  w: allKontentItemPage(
    filter: {elements: {content: {value: {elemMatch: {system: {type: {eq: "content___sotd"}}}}},
    title: {value: {regex: "/^(W|w).+/"}}}}
    sort: { elements: {url: {value: ASC}}}  ) {
    totalCount
    nodes {
      ...scientistLink
    }
  }
  xyz: allKontentItemPage(
    filter: {elements: {content: {value: {elemMatch: {system: {type: {eq: "content___sotd"}}}}},
    title: {value: {regex: "/^([X-Z]|[x-z]).+/"}}}}
    sort: { elements: {url: {value: ASC}}}  ) {
    totalCount
    nodes {
      ...scientistLink
    }
  }
  numbers: allKontentItemPage(
    filter: {elements: {content: {value: {elemMatch: {system: {type: {eq: "content___sotd"}}}}},
    title: {value: {regex: "/^[0-9].+/"}}}}
    sort: { elements: {url: {value: ASC}}}  ) {
    totalCount
    nodes {
      ...scientistLink
    }
  }
}

fragment scientistLink on kontent_item_page {
  id
  elements {
    url {
      url
    }
    title {
      value
    }
    display_publish_date {
      value(formatString: "YYYY")
    }
  }
}
`;

exports.normalizer = (queryResult) => {
  return formatScientistLinks(queryResult);
};

const formatScientistLinks = (queryResult) => {
  const data = queryResult.data;
  const keys = Object.keys(data);

  let scientistLinks = keys.map((key) => {
    return {
      letter: key,
      links: data[key].nodes.map((node) => {
        const url = get(node, "elements.url.url");
        const title = get(node, "elements.title.value");
        const year = get(node, "elements.display_publish_date.value");

        return { url, title, year };
      }),
    };
  });

  return scientistLinks;
};
